import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import {
  Container,
  Button,
  Box,
  Typography,
  Grid,
  Menu,
  Modal,
  MenuItem,
  IconButton,
  CircularProgress,
  TextField,
  Popover,
  Paper,
  useMediaQuery,
  Badge,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
// import logoSm from "/logo-removebg-preview.png";
import UpcomingIcon from "@mui/icons-material/Upcoming";
import Select from "react-select";
import Tooltip from "@mui/material/Tooltip";
import { ToastContainer, toast } from "react-toastify";
import { DataGrid } from "@mui/x-data-grid";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import axios from "axios";
import { useAlert } from "react-alert";
import HelpIcon from "@mui/icons-material/Help";
import fileDownload from "js-file-download";
import Moment from "moment";
import { useForm, Controller } from "react-hook-form";
import Fade from "@mui/material/Fade";
import { FileUploader } from "react-drag-drop-files";
import LoadingButton from "@mui/lab/LoadingButton";
import Download from "@mui/icons-material/Download";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import { confirmAlert } from "react-confirm-alert"; // Import
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { Backdrop } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
const UpdatesDropDown = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const rights = useSelector((state) => state.login.rights);
  const [unreadUpdateIds, setUnreadUpdateIds] = useState([]);

  const handleClick = async (event) => {
    setAnchorEl(event.currentTarget);
    if (!unreadUpdateIds || unreadUpdateIds.length === 0) return;
    try {
      await Promise.all(
        unreadUpdateIds.map((docId) =>
          axios.post(
            `${process.env.REACT_APP_API_URL}/PatientDocument/MarkDocumentViewed?userId=${userId}&documentId=${docId}`,
            {},
            { headers }
          )
        )
      );
      setRecentCount(0);
      setUnreadUpdateIds([]);
    } catch (error) {
      console.error("Error marking documents as viewed", error);
    }
  };

  const handleCloseDrop = () => {
    setAnchorEl(null);
  };

  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const alert = useAlert();
  const [docslist, setdocslist] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [docError, setdocError] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [date, setdate] = useState(Moment().format("YYYY-MM-DD"));
  const [Splash, setSplash] = useState(false);
  const [comments, setcomments] = useState("");
  const [LinkUrl, setLinkUrl] = useState("");

  const [LinkName, setLinkName] = useState("");
  const [base64, setbase64] = useState("");
  const [DocumentName, setDocumentName] = useState("");
  const options = [
    { value: "upload", label: "Upload Document" },
    { value: "weburl", label: "Web URL" },
  ];
  const [documentType, setDocumentType] = useState(null);
  const [opendocs, setopendocs] = useState(false);
  const [urlFile, seturlFile] = useState("");
  const [urldownload, seturldownload] = useState("");
  const [DocName, setDocName] = useState("");
  const [FullDocName, setFullDocName] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [file, setFile] = useState(null);

  const [filename, setfilename] = useState([]);
  const [base64Data, setBase64Data] = useState([]);
  const [totalProgress, setTotalProgress] = React.useState(0);
  const [savedFiles, setSavedFiles] = React.useState([]);

  const fields = [
    "id",
    "documentName",
    "fileUrl",
    "patientId",
    "practiceId",
    "deleted",
    "date",
    "createdBy",
    "clientCreatedDate",
    "updatedBy",
    "clientUpdatedDate",
    "createdDate",
    "updatedDate",
    "base64",
    "authId",
    "authorizationcptId",
    "notificationId",
    "type",
    "referringProvider",
    "referringPhysiciansId",
  ];
  const defValues = {
    id: 0,
    documentName: "",
    fileUrl: "",
    patientId: 0,
    practiceId: "",
    date: "",
    createdBy: "",
    referringProvider: "",
    referringPhysiciansId: 0,
    Deleted: false,
    clientCreatedDate: "",
    updatedBy: "",
    clientUpdatedDate: "",
    createdDate: "",
    updatedDate: "",
    base64: "",
    authorizationcptId: "",
    notificationId: "",
    authId: "",
    type: "",
  };
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [Delbyid, setDelbyid] = useState(false);
  const handleDelete = (cell) => {
    // Perform your delete logic here
    const postData = {
      id: Delbyid,
      deleted: true,
    };
    axios
      .post(
        `${
          process.env.REACT_APP_API_URL
        }/PatientDocument/PatientDocument?patientId=${-11}`,
        postData,
        {
          headers,
        }
      )
      .then((response) => {
        setRefresh(!refresh);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
    // Close the dialog
    setDialogOpen(false);
  };
  const {
    register,
    control,
    handleSubmit,
    setValue,
    reset,
    getValues,
    clearErrors,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    defaultValues: defValues,
  });

  const handleOpenn = () => {
    setOpen(true);
    setSubmitting(false);
    setbase64("");
    setfilename("");
  };
  function applyRefresh() {
    setRefresh(!refresh);
  }
  const handleClose = () => {
    setopendocs(false);
    setFile(null);
    setOpen(false);
    setSubmitting(false);
    setRefresh(true);
    setfilename([]);
    setBase64Data([]);
    setDocumentName("");
    setDocumentType(null);
    setdate("");
    setSplash(false);
    setcomments("");
    setdocError(false);
    setLinkUrl("");
    setLinkName("");
  };
  const [recentCount, setRecentCount] = useState(0);
  useEffect(() => {
    setSpinner(true);
    axios
      .get(
        `${
          process.env.REACT_APP_API_URL
        }/PatientDocument/PatientDocumentList?patientId=${-11}`,
        { headers }
      )
      .then((response) => {
        fields.forEach((field) => {
          setValue(field, response[field]);
        });
        setSpinner(false);
        setdocslist(response);

        // const now = new Date();
        // const sevenDaysAgo = new Date();
        // sevenDaysAgo.setDate(now.getDate() - 7);

        // const recentDocs = response.filter((doc) => {
        //   if (!doc.createdDate) return false;
        //   const docDate = new Date(doc.createdDate);
        //   return docDate >= sevenDaysAgo && docDate <= now;
        // });

        // ✅ Update count state
        // setRecentCount(recentDocs.length);
      })

      .catch((error) => {
        setSpinner(false);
        console.error("There was an error!", error);
      });
  }, [refresh, anchorEl]);

  const styleofmodal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 950,
    // height: 500,
    backgroundColor: "#5c6b74",
    border: "2px solid #1E1B3A",
    boxShadow: 24,
    p: 4,
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    height: "70vh", // Fixed height using viewport units (or you can use px like "600px")
    bgcolor: "background.paper",
    border: "2px solid #377562",
    boxShadow: 24,
    overflowY: "auto", // This enables vertical scrolling when content overflows
    maxHeight: "90vh", // Optional: prevents the modal from becoming too tall
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  const [sizeError, setSizeError] = useState(false);
  const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB in bytes
  const handleChangeforfile = async (files) => {
    const newFilenames = [];
    const newBase64Data = [];

    // RESET first
    setSizeError(false);
    setfilename([]);
    setBase64Data([]);

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // ❌ Size more than 10MB?
      if (file.size > MAX_FILE_SIZE) {
        setSizeError(true);
        toast.error(`"${file.name}" exceeds 10 MB limit`);
        return; // ⛔ Stop here
      }

      const base64 = await fileToBase64(file);
      newFilenames.push(file.name);
      newBase64Data.push(base64);
    }

    setfilename(newFilenames);
    setBase64Data(newBase64Data);
    setdocError(false);
  };

  const onSubmit = async (data) => {
    if (!date) {
      setdocError(true);
      setSubmitting(false);
      return;
    }

    setdocError(false);
    setSubmitting(true);
    setSavedFiles([]);

    let postData = [];
    let totalLength = 0;

    // 1️⃣ If files exist → push normally
    if (base64Data.length > 0) {
      for (let i = 0; i < base64Data.length; i++) {
        totalLength += base64Data[i].length;

        postData.push({
          patientId: -11,
          date,
          documentName: filename[i] || DocumentName,
          base64: base64Data[i], // file
          linkText: LinkName,
          linkUrl: LinkUrl,
          comments,
          Splash,
          view: false,
        });
      }
    }

    // 2️⃣ If NO file → still push one record
    if (base64Data.length === 0) {
      totalLength = 1; // prevents divide-by-zero

      postData.push({
        patientId: -11,
        date,
        documentName: DocumentName || LinkName,
        base64: "", // NO FILE
        linkText: LinkName,
        linkUrl: LinkUrl,
        comments,
        Splash,
        view: false,
      });
    }

    try {
      const requests = postData.map((documentData, index) => {
        const config = {
          onUploadProgress: (progressEvent) => {
            const progress = Math.round(
              (progressEvent.loaded / totalLength) * 100
            );
            setTotalProgress(progress > 100 ? 100 : progress);
          },
          headers,
        };

        return axios
          .post(
            `${
              process.env.REACT_APP_API_URL
            }/PatientDocument/PatientDocument?patientId=${-11}`,
            documentData,
            config
          )
          .then(() => setSavedFiles((prev) => [...prev, index]));
      });

      await Promise.all(requests);

      setSubmitting(false);
      setSpinner(false);
      setOpen(false);

      alert.success("Document uploaded successfully.", {
        type: "success",
        onClose: () => {
          handleClose();
          applyRefresh();
        },
      });
    } catch (error) {
      console.error(error);
      setSubmitting(false);
      setSpinner(false);

      toast.error(`Error: ${error.message}`, { type: "error" });
    }
  };

  const download = (url, filename) => {
    setSpinner(true);
    setSubmitting(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/PatientDocument/DownloadAWSFile?path=${url}`,
        {
          headers,
          responseType: "blob",
        }
      )
      .then((res) => {
        setopendocs(false);
        setSpinner(false);
        setSubmitting(false);
        fileDownload(res, filename);
      })
      .catch((err) => {
        setSubmitting(false);
        console.log(err);
      });
  };
  const handleRename = (index, newName) => {
    const updatedFilenames = [...filename];
    updatedFilenames[index] = newName; // Update the filename at the specific index
    setfilename(updatedFilenames);
  };
  const OPEN = Boolean(anchorEl);
  // That Api Is Here Just for Sync Data In Db From third Party
  useEffect(() => {
    const fetchUnreadFaxes = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/Fax/GetInboxFaxes`,
          { headers }
        );

        // Assuming response.data contains the fax list
        const unreadFaxes = response.data.filter(
          (fax) => fax.viewedStatus?.toUpperCase() === "UNREAD"
        );

        const unreadFaxCount = unreadFaxes.length;
        localStorage.setItem("unreadFaxCount", unreadFaxCount);
      } catch (error) {
        console.error("Error fetching faxes:", error);
      }
    };

    fetchUnreadFaxes();

    const intervalId = setInterval(fetchUnreadFaxes, 30000);

    return () => clearInterval(intervalId);
  }, []);
 useEffect(() => {
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Eligibility/SyncClaimMdPayers`,null,
        { headers }
      )
      .then((res) => {
       
      })
      .catch((err) => console.error("Eligibility check failed", err));
  }, []);
  const isTabletOrMobile = useMediaQuery("(max-width: 768px)");

  const [openSplash, setOpenSplash] = useState(false);
  const [splashDocs, setSplashDocs] = useState([]); // ✅ renamed
  const [selectedSplashDoc, setSelectedSplashDoc] = useState(null);
  const [fileUrl, setFileUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const userId = localStorage.getItem("UserId");
  useEffect(() => {
    if (!userId) return;
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/PatientDocument/GetSplashDocuments?userId=${userId}`,
        { headers }
      )
      .then((res) => {
        setRecentCount(res?.unreadUpdatesCount || 0);
        setUnreadUpdateIds(res?.unreadUpdateIds || []);
        if (
          res?.splashDocuments &&
          Array.isArray(res?.splashDocuments) &&
          res?.splashDocuments?.length > 0
        ) {
          setSplashDocs(res?.splashDocuments);
          setOpenSplash(true);
        }
      })
      .catch((err) => console.error("Splash check failed", err));
  }, [userId, refresh]);

  const handlePreview = async (doc) => {
    setSelectedSplashDoc(doc);
    setLoading(true);
    setFileUrl("");

    if (!doc.fileUrl && doc.linkUrl) {
      // Only link — no need to call API
      setLoading(false);
      return;
    }

    if (!doc.fileUrl && !doc.linkUrl) {
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/PatientDocument/ViewPatientDocument?path=${doc.fileUrl}`,
        { headers }
      );

      setFileUrl(response);
    } catch (err) {
      console.error("Error loading document", err);
    } finally {
      setLoading(false);
    }
  };

  const handleMarkViewed = async () => {
    if (!selectedSplashDoc) return;

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/PatientDocument/MarkDocumentViewed?userId=${userId}&documentId=${selectedSplashDoc.id}`,
        {},
        { headers }
      );

      setSplashDocs((prev) =>
        prev.filter((d) => d.id !== selectedSplashDoc.id)
      );
      setSelectedSplashDoc(null);
      setFileUrl("");

      // Close splash if no docs left
      if (splashDocs.length <= 1) {
        setOpenSplash(false);
      }
    } catch (err) {
      console.error("Mark viewed failed", err);
    }
  };

  const handleCancel = () => {
    setOpenSplash(false);
  };
  const handleAcknowledgeAll = async () => {
    if (!splashDocs.length) {
      setOpenSplash(false);
      return;
    }

    try {
      // You can call a bulk API endpoint if backend supports it,
      // otherwise just loop through each document
      await Promise.all(
        splashDocs.map((doc) =>
          axios.post(
            `${process.env.REACT_APP_API_URL}/PatientDocument/MarkDocumentViewed?userId=${userId}&documentId=${doc.id}`,
            {},
            { headers }
          )
        )
      );

      // Clear state after all are marked
      setSplashDocs([]);
      setSelectedSplashDoc(null);
      setFileUrl("");
      setOpenSplash(false);
    } catch (err) {
      console.error("Acknowledge all failed", err);
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={openSplash}
        fullScreen
        PaperProps={{
          sx: {
            background: "linear-gradient(135deg, #0f172a, #1e293b)",
            color: "#fff",
            position: "relative",
            overflow: "hidden",
          },
        }}
      >
        {/* Logo */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            pt: 4,
            pb: 1,
          }}
        >
          <motion.img
            src="/logo-removebg-preview.png"
            alt="logo"
            initial={{ rotateY: 0, scale: 0.9, opacity: 0 }}
            animate={{ rotateY: 360, scale: 1, opacity: 1 }}
            transition={{ duration: 4, repeat: Infinity, ease: "linear" }}
            style={{
              height: window.innerWidth < 768 ? "38px" : "48px",
              marginTop: "-10px",
              boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
              borderRadius: "10px",
            }}
          />
        </Box>

        {/* Title */}
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "26px",
            letterSpacing: 0.5,
            color: "#E0E7FF",
            textShadow: "0 0 10px rgba(59,130,246,0.6)",
            mb: 1,
          }}
        >
          📄 New Updates Available
        </DialogTitle>

        {/* Main Content */}
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 4,
            px: 4,
            pb: 8,
            height: "100%",
          }}
        >
          {/* Left List */}
          <Box
            component={motion.div}
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            sx={{
              width: selectedSplashDoc ? "35%" : "100%",
              overflowY: "auto",
              backgroundColor: "rgba(255,255,255,0.05)",
              p: 2,
              borderRadius: "12px",
            }}
          >
            {splashDocs.map((doc) => (
              <Paper
                key={doc.id}
                elevation={2}
                sx={{
                  mb: 2,
                  p: 2,
                  backgroundColor:
                    selectedSplashDoc?.id === doc.id
                      ? "rgba(59,130,246,0.25)"
                      : "rgba(255,255,255,0.05)",
                  borderRadius: "10px",
                  cursor: "pointer",
                  transition: "0.3s",
                  "&:hover": { backgroundColor: "rgba(59,130,246,0.15)" },
                }}
              >
                <Tooltip title={doc.documentName}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      color: "#60a5fa",
                      fontWeight: 600,
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {doc.documentName}
                  </Typography>
                </Tooltip>

                <Typography sx={{ color: "#cbd5e1", fontSize: "13px" }}>
                  Comments: {doc.comments || "N/A"}
                </Typography>

                <Box textAlign="right" mt={1}>
                  <Button
                    size="small"
                    variant="contained"
                    onClick={() => handlePreview(doc)}
                    sx={{
                      textTransform: "none",
                      background:
                        "linear-gradient(90deg, #3b82f6, #60a5fa, #93c5fd)",
                      fontWeight: 600,
                    }}
                  >
                    Preview
                  </Button>
                </Box>
              </Paper>
            ))}

            {splashDocs.length === 0 && (
              <Typography sx={{ textAlign: "center", color: "#94a3b8" }}>
                No new documents.
              </Typography>
            )}
          </Box>

          {/* Right Side Preview */}
          {selectedSplashDoc && (
            <motion.div
              initial={{ opacity: 0, x: 80 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              style={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(255,255,255,0.05)",
                borderRadius: "16px",
                padding: "24px",
              }}
            >
              {loading ? (
                <CircularProgress color="inherit" />
              ) : !selectedSplashDoc.fileUrl && !selectedSplashDoc.linkUrl ? (
                <Typography sx={{ color: "#fca5a5" }}>
                  ❌ No file or link available for this document.
                </Typography>
              ) : fileUrl ? (
                <>
                  <Typography variant="body2" style={{ marginBottom: 8 }}>
                    If the content does not display below,{" "}
                    <span
                      onClick={() =>
                        window.open(
                          selectedSplashDoc.linkUrl
                            ? selectedSplashDoc.linkUrl
                            : fileUrl,
                          "_blank"
                        )
                      }
                      style={{
                        color: "#1976d2",
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      click here to open in new window
                    </span>
                  </Typography>

                  <iframe
                    src={fileUrl}
                    title="Document Preview"
                    style={{
                      width: "100%",
                      height: "70vh",
                      border: "none",
                      borderRadius: "12px",
                    }}
                  />
                </>
              ) : selectedSplashDoc.linkUrl ? (
                <Typography sx={{ color: "#60a5fa" }}>
                  🔗 This document contains only a link.
                  <br />
                  <strong
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                    onClick={() =>
                      window.open(selectedSplashDoc.linkUrl, "_blank")
                    }
                  >
                    Open Link
                  </strong>
                </Typography>
              ) : null}

              <Box display="flex" gap={3} mt={3}>
                <Button
                  variant="contained"
                  onClick={handleMarkViewed}
                  sx={{ px: 4, py: 1, fontWeight: 600 }}
                >
                  Mark as Viewed
                </Button>

                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => {
                    setSelectedSplashDoc(null);
                    setFileUrl("");
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </motion.div>
          )}
        </DialogContent>

        <Box sx={{ position: "absolute", bottom: 10, right: 30 }}>
          <Button
            variant="contained"
            color="success"
            onClick={handleAcknowledgeAll}
          >
            🌿 Acknowledge and Continue
          </Button>
        </Box>
      </Dialog>

      <div className="d-flex">
        <Grid
          style={{
            display: "flex",
            marginTop: "-15px",
          }}
        >
          <Badge
            badgeContent={recentCount}
            color="error"
            overlap="circular"
            sx={{
              "& .MuiBadge-badge": {
                fontSize: "0.7rem",
                height: 18,
                minWidth: 18,
                top: 20, // 👈 moved closer vertically
                right: 8, // 👈 moved closer horizontally
              },
            }}
          >
            <Button
              variant="contained"
              onClick={handleClick}
              sx={{
                backgroundColor: "#0d7f6a",
                color: "white",
                borderRadius: "30px",
                textTransform: "none",
                marginTop: "19px",
                minWidth: isTabletOrMobile ? "40px" : "150px",
                height: isTabletOrMobile ? "40px" : "38px",
                padding: isTabletOrMobile ? "0" : "0 16px",
                "&:hover": {
                  background: "#2c5e4e",
                },
              }}
            >
              <UpcomingIcon sx={{ fontSize: 20 }} />
              {!isTabletOrMobile && " UPDATES"}
            </Button>
          </Badge>
        </Grid>
      </div>

      <Popover
        open={OPEN}
        anchorEl={anchorEl}
        onClose={handleCloseDrop}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          style: {
            width: "500px",
            height: "490px",
            padding: "20px",
            backgroundColor: "#5c6b74", // softer black
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 8px 30px rgba(0, 0, 0, 0.4)",
          },
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          {rights.Add_UpDates && (
            <Button
              variant="contained"
              startIcon={<AddOutlinedIcon />}
              onClick={handleOpenn}
              sx={{
                backgroundColor: "#377562",
                "&:hover": { backgroundColor: "#2d5e4f" },
                textTransform: "none",
                borderRadius: "8px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
              }}
            >
              Add New
            </Button>
          )}
          <Button
            variant="contained"
            startIcon={<CachedOutlinedIcon />}
            onClick={applyRefresh}
            sx={{
              backgroundColor: "#377562",
              "&:hover": { backgroundColor: "#2d5e4f" },
              textTransform: "none",
              borderRadius: "8px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            }}
          >
            Refresh
          </Button>
        </Box>
        <Box
          sx={{
            mb: 3,
            textAlign: "center",
            borderBottom: "2px solid #00bcd4",
            pb: 1,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: "#00bcd4",
              textTransform: "uppercase",
              letterSpacing: "2px",
            }}
          >
            Updates
          </Typography>
        </Box>
        <Box
          sx={{
            height: "380px",
            overflowY: "auto",
            pr: 1,
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#2c2c2c",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#555",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#777",
            },
          }}
        >
          {spinner ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{ height: "100%" }}
            >
              <CircularProgress />
            </Box>
          ) : docslist === null || docslist.length === 0 ? (
            <Typography align="center" sx={{ color: "#aaa" }}>
              No Record Found
            </Typography>
          ) : (
            docslist.map((doc, index) => (
              <Paper
                key={index}
                elevation={1}
                sx={{
                  backgroundColor: "#1E1B3A",
                  color: "#fff",
                  p: 2,
                  mb: 2,
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Tooltip title={doc.documentName} placement="top">
                    <Button
                      disabled={!doc.linkUrl && !doc.fileUrl}
                      onClick={() => {
                        setopendocs(true);
                        setLinkName(doc.linkText);
                        setLinkUrl(doc.linkUrl);
                        setFullDocName(doc.documentName);
                        const url = doc.fileUrl;
                        seturldownload(doc.fileUrl);

                        if (!doc.linkUrl) {
                          axios
                            .get(
                              `${process.env.REACT_APP_API_URL}/PatientDocument/ViewPatientDocument?path=${url}`,
                              { headers }
                            )
                            .then((response) => seturlFile(response))
                            .catch((error) =>
                              console.error("There was an error!", error)
                            );

                          const arr = doc.documentName.split(".");
                          setDocName(
                            arr.length > 0 ? arr[1].toLowerCase() : ""
                          );
                        }
                      }}
                      sx={{
                        color: "#007bff",
                        fontWeight: 500,
                        textTransform: "none",
                        fontSize: "14px",
                      }}
                    >
                      {doc.documentName}
                    </Button>
                  </Tooltip>
                  <Typography
                    variant="body2"
                    sx={{ color: "#ffff", fontSize: "13px", mt: 0.5 }}
                  >
                    Date: {Moment(doc.date).format("dddd, MMMM D, YYYY")}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "#ffff", fontSize: "13px", mt: 0.5 }}
                  >
                    Comments: {doc.comments}
                  </Typography>
                </Box>

                {rights.Delete_Updates && (
                  <Tooltip title="Delete">
                    <DeleteIcon
                      sx={{ color: "red", cursor: "pointer" }}
                      onClick={() => {
                        setDialogOpen(true);
                        setDelbyid(doc.id);
                      }}
                    />
                  </Tooltip>
                )}
              </Paper>
            ))
          )}
        </Box>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
        >
          <Fade in={open}>
            <Box sx={style}>
              <Grid container columnSpacing={0}>
                <Grid
                  container
                  spacing={0}
                  style={{
                    backgroundColor: "#377562",
                  }}
                >
                  <Grid
                    item
                    xs={9}
                    style={{
                      fontWeight: 500,
                      backgroundColor: "#377562",
                      marginTop: "10px",
                    }}
                  >
                    <Typography
                      style={{
                        fontWeight: "bold",
                        marginLeft: "7px",
                        fontSize: "18px",
                        color: "white",
                      }}
                    >
                      Upload
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Button
                      onClick={handleClose}
                      variant="gradient"
                      // disabled={submitting}
                      style={{
                        marginTop: "10px",
                        float: "right",
                        marginBottom: "10px",
                        // width: "80px",
                        height: "35px",

                        color: "black",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                    >
                      <CancelOutlinedIcon
                        fontSize="medium"
                        style={{
                          color: "red",

                          paddingBottom: "2px",
                        }}
                      ></CancelOutlinedIcon>
                    </Button>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={11}
                  style={{ width: 250, marginTop: 15, marginLeft: 15 }}
                >
                  <Typography style={{ color: "black" }}>Date</Typography>
                  <TextField
                    type="date"
                    size="small"
                    value={date}
                    onChange={(e) => {
                      setdate(e.target.value);
                      setdocError(false);
                    }}
                    width="auto"
                    fullWidth
                    placeholder="Select date"
                  />
                </Grid>
                <Grid
                  item
                  xs={11}
                  style={{ width: 250, marginTop: 15, marginLeft: 15 }}
                >
                  <Typography style={{ color: "black" }}>Comments</Typography>
                  <TextField
                    size="small"
                    value={comments}
                    onChange={(e) => {
                      setcomments(e.target.value);
                    }}
                    width="auto"
                    fullWidth
                    multiline
                    rows={2}
                    placeholder="Please Enter Comments..."
                  />
                </Grid>
                <Grid
                  item
                  xs={11}
                  style={{ width: 250, marginTop: 15, marginLeft: 15 }}
                >
                  <Typography style={{ color: "black" }}>
                    Document Type
                  </Typography>
                  <Select
                    options={options}
                    value={documentType}
                    onChange={setDocumentType}
                    placeholder="Select Document Type"
                  />
                </Grid>
                <Grid
                  item
                  xs={11}
                  sx={{
                    width: 250,
                    marginTop: 2,
                    marginLeft: 2,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={Splash}
                        onClick={() => setSplash(!Splash)} // 👈 toggle splash
                        color="primary"
                        sx={{
                          "&.Mui-checked": {
                            color: "#1976d2", // nice blue color when checked
                          },
                        }}
                      />
                    }
                    label={
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: 500,
                          fontSize: "15px",
                        }}
                      >
                        Add to Splash Page
                      </Typography>
                    }
                    sx={{
                      margin: 0,
                      "& .MuiFormControlLabel-label": {
                        marginLeft: "4px",
                      },
                    }}
                  />
                </Grid>

                {documentType?.value === "weburl" && (
                  <>
                    <Grid
                      item
                      xs={11}
                      style={{ width: 250, marginTop: 15, marginLeft: 15 }}
                    >
                      <Typography style={{ color: "black" }}>
                        Link Name
                      </Typography>
                      <TextField
                        size="small"
                        value={LinkName}
                        onChange={(e) => {
                          setLinkName(e.target.value);
                        }}
                        width="auto"
                        fullWidth
                        placeholder="Input Link Name"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={11}
                      style={{ width: 250, marginTop: 15, marginLeft: 15 }}
                    >
                      <Typography style={{ color: "black" }}>
                        Link Url
                      </Typography>
                      <TextField
                        size="small"
                        value={LinkUrl}
                        onChange={(e) => {
                          setLinkUrl(e.target.value);
                          setdocError(false);
                        }}
                        width="auto"
                        fullWidth
                        placeholder="Input Link Url"
                      />
                    </Grid>
                  </>
                )}
                {filename.length > 0 && (
                  <Grid item xs={12} style={{ marginTop: 15, marginLeft: 15 }}>
                    <h4>Uploaded Files (Edit Names Below):</h4>
                    {filename.map((name, index) => (
                      <Grid
                        container
                        spacing={2}
                        key={index}
                        style={{ marginBottom: 10 }}
                      >
                        <Grid item xs={8}>
                          <TextField
                            fullWidth
                            label={`File ${index + 1}`}
                            value={name}
                            size="small"
                            onChange={(e) =>
                              handleRename(index, e.target.value)
                            }
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                )}
              </Grid>
              {documentType?.value === "upload" && (
                <>
                  <Grid item xs={12} style={{ marginTop: 15, marginLeft: 15 }}>
                    <Button
                      className="Button"
                      variant="contained"
                      component="label"
                    >
                      Upload
                      <input
                        type="file"
                        name="file"
                        accept="video/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/*"
                        onInput={(e) => handleChangeforfile(e.target.files)}
                        style={{ display: "none" }}
                        multiple
                      />
                    </Button>
                  </Grid>

                  <Grid item xs={12} style={{ marginTop: 15, marginLeft: 15 }}>
                    <FileUploader
                      multiple={true}
                      handleChange={handleChangeforfile}
                      name="file"
                    />
                  </Grid>
                </>
              )}
              {sizeError && (
                <Grid item xs={12} style={{ marginTop: 15, color: "red" }}>
                  Please select files smaller than 10 MB
                </Grid>
              )}
              <Grid
                item
                xs={12}
                style={{ marginTop: "5px", marginLeft: 15 }}
              ></Grid>
              <Grid>
                {docError ? (
                  <Typography style={{ color: "red" }}>
                    Please Select Document Date
                  </Typography>
                ) : null}
              </Grid>
              <Grid item xs={12} style={{ fontWeight: 500 }}>
                {submitting ? (
                  <Grid>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <CircularProgress />
                    </Box>

                    <Typography variant="bold" component="div" color="#ba000d">
                      Please wait your data is being saved..
                    </Typography>
                  </Grid>
                ) : (
                  ""
                )}
                <Button
                  className="Button"
                  variant="contained"
                  style={{ float: "right", width: "80", marginBottom: "5px" }}
                  onClick={handleClose}
                >
                  Close
                </Button>
                <Button
                  className="Button"
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit(onSubmit)}
                  disabled={submitting}
                  style={{
                    float: "right",
                    width: "80px",
                    marginRight: "5px",
                    marginLeft: "5px",
                  }}
                >
                  Save
                </Button>
              </Grid>
            </Box>
          </Fade>
        </Modal>
        <Modal
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          onClose={handleClose}
          open={opendocs}
        >
          <Box sx={styleofmodal}>
            <Grid container>
              <Grid
                item
                xs={9}
                style={{
                  fontWeight: 500,
                  backgroundColor: "#1E1B3A",
                  marginBottom: 5,
                  borderRadius: "5px",
                  paddingLeft: "10px",
                }}
              >
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                  color="#fff"
                >
                  {FullDocName}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                {submitting ? (
                  <LoadingButton
                    loading
                    loadingIndicator="Downloading"
                    // style={{ position: 'absolute', right: '28px', bottom: '11px' }}
                    color="primary"
                    variant="contained"
                  >
                    Fetch data
                  </LoadingButton>
                ) : (
                  <Button
                    className="Button"
                    size="small"
                    startIcon={<Download />}
                    onClick={() => {
                      download(`${urldownload}`, FullDocName);
                    }}
                    variant="contained"
                    disabled={submitting}
                    style={{
                      // backgroundColor: 'primary',
                      color: "white",
                      float: "right",
                      // position: 'absolute',
                      // marginRight: '28px',
                      // bottom: '11px'
                    }}
                  >
                    Download
                  </Button>
                )}
              </Grid>
              <Grid item xs={1}>
                <CancelOutlinedIcon
                  onClick={handleClose}
                  fontSize="large"
                  color="red"
                  cursor="pointer"
                  style={{ color: "red", marginBottom: 5, float: "right" }}
                ></CancelOutlinedIcon>
              </Grid>
              {LinkUrl ? (
                <Grid item xs={12}>
                  <Typography variant="body2" style={{ marginBottom: 8 }}>
                    If the content does not display below,{" "}
                    <span
                      onClick={() =>
                        window.open(
                          LinkUrl,
                          "_blank",
                          "toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=200,width=1000,height=700"
                        )
                      }
                      style={{
                        color: "#1976d2",
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      click here to open in a new window
                    </span>
                    .
                  </Typography>
                  <iframe
                    title="Linked Document"
                    src={LinkUrl}
                    height="500px"
                    width="100%"
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                    }}
                  ></iframe>
                </Grid>
              ) : (DocName && DocName == "jpg") ||
                DocName == "png" ||
                DocName == "jpeg" ? (
                <>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={8}>
                    <img
                      height="500px"
                      width="500px"
                      border="4px solid #000"
                      src={`${urlFile}`}
                    ></img>
                  </Grid>
                  <Grid item xs={2}></Grid>
                </>
              ) : (
                <>
                  <Grid item xs={12}>
                    <iframe
                      height="500px"
                      width="875px"
                      src={`${urlFile}`}
                    ></iframe>
                  </Grid>
                </>
              )}
              <Grid item xs={12}></Grid>
            </Grid>
          </Box>
        </Modal>
        <Dialog
          open={isDialogOpen}
          onClose={() => setDialogOpen(false)}
          aria-labelledby="delete-dialog-title"
          BackdropComponent={Backdrop}
          BackdropProps={{
            invisible: true,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "8px",
              width: "500px",
              padding: "20px",
            }}
          >
            <ErrorOutlineIcon style={{ fontSize: "100px", color: "red" }} />
            <DialogTitle
              style={{
                fontWeight: "bold",
                color: "black",
                fontSize: " 1.25rem",
              }}
            >
              Are you sure?
            </DialogTitle>
            <h5
              style={{
                textAlign: "center",
                fontSize: "16px",
                fontWeight: "normal",
                color: "#444444",
              }}
            >
              You won't be able to revert this!
            </h5>
            <DialogContent>
              <DialogContentText>
                <Grid style={{ marginTop: "1rem" }}>
                  <Button
                    onClick={() => setDialogOpen(false)}
                    style={{
                      backgroundColor: "#6c7c84",
                      color: "white",
                      marginBottom: "1rem",
                    }}
                  >
                    No, cancel!
                  </Button>
                  <Button
                    onClick={handleDelete}
                    style={{
                      backgroundColor: "red",
                      color: "white",
                      marginLeft: "1rem",
                      marginBottom: "1rem",
                      border: "1px solid #b4acec",
                    }}
                  >
                    Yes, delete it!
                  </Button>
                </Grid>
              </DialogContentText>
            </DialogContent>
          </div>
        </Dialog>
      </Popover>
    </React.Fragment>
  );
};

export default withTranslation()(UpdatesDropDown);

UpdatesDropDown.propTypes = {
  t: PropTypes.any,
};
